<template>
<div class="switch-button" @click="$emit('action')">
  <div class="label"><slot /></div>
  <SwitchHandle :on="on" />
</div>
</template>

<script>
import SwitchHandle from "./SwitchHandle.vue";
export default {
  name: "SwitchButton",
  components: {SwitchHandle},
  props: {
    on: Boolean
  }
}
</script>

<style lang="scss">

.side-menu .switch-button {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  min-height: 44px;
  line-height: 1.15;

  padding: 0 0.85em;

  > .label {
    flex-grow: 1;

    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  > .switch {
    margin: 0.5em 0;
  }

  &:hover {
    background: rgba(67, 217, 255, 0.10) !important;
  }

  &:active {
    border-color: rgba(55, 242, 154, 0.40) !important;
    background: linear-gradient(135deg, rgba(55, 242, 154, 0.16), rgba(67, 217, 255, 0.10)) !important;
  }
}

</style>